import $ from 'jquery'

const RECAPTCHA_LOAD_CALLBACK_NAME = 'grccb'

const Recaptcha = {
  isLoading: false,

  pendingRequests: [],

  request() {
    return new Promise(resolve => {
      if (window.grecaptcha) {
        return resolve
      }

      this.pendingRequests.push(resolve)
      this.load()
    })
  },

  load() {
    if (this.isLoading) {
      return
    }

    this.isLoading = true
    window[RECAPTCHA_LOAD_CALLBACK_NAME] = this.complete.bind(this)

    $('body').append(
      '<script src="https://www.google.com/recaptcha/api.js?onload=' +
        RECAPTCHA_LOAD_CALLBACK_NAME +
        '&render=explicit"" async defer></script>'
    )
  },

  complete() {
    this.isLoading = false
    this.resolvePrendingRequests()
  },

  resolvePrendingRequests() {
    this.pendingRequests.forEach(resolve => {
      resolve()
    })
  },

  render(container, sitekey, callback, expiredCallback, theme = 'light', size = 'normal') {
    this.request().then(() => {
      window.grecaptcha.render(container, {
        sitekey,
        callback,
        'expired-callback': expiredCallback,
        theme,
        size,
      })
    })
  },
}

export default Recaptcha
